import { IBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { createConverterRulesArray } from 'common/builder/components/chart/FlowChart/lib/utils/createConverterRulesArray'
import { FlowChartBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'

import { AttachmentBlockGenericConverterRule } from './converterRules/AttachmentBlockGenericConverterRule'
import { AttachmentPreviewBlockGenericConverterRule } from './converterRules/AttachmentPreviewBlockGenericConverterRule'
import { CardsBlockGenericConverterRule } from './converterRules/CardsBlockGenericConverterRule'
import { DelayBlockGenericConverterRule } from './converterRules/DelayBlockGenericConverterRule'
import { DynamicBlockGenericConverterRule } from './converterRules/DynamicBlockGenericConverterRule'
import { FallbackBlockGenericConverterRule } from './converterRules/FallbackBlockGenericConverterRule'
import { QuickRepliesBlockGenericConverterRule } from './converterRules/QuickRepliesBlockGenericConverterRule'
import { SubscribeRequestBlockGenericConverterRule } from './converterRules/SubscribeRequestBlockGenericConverterRule'
import { TextBlockGenericConverterRule } from './converterRules/TextBlockGenericConverterRule'
import { UserInputBlockGenericConverterRule } from './converterRules/UserInputBlockGenericConverterRule'

export const GenericBlocksConversionRules: Array<
  ConverterRule<IBlock, FlowChartBlock, BlockConverterRulePayload>
> = createConverterRulesArray(
  [
    TextBlockGenericConverterRule,
    AttachmentPreviewBlockGenericConverterRule,
    AttachmentBlockGenericConverterRule,
    DelayBlockGenericConverterRule,
    DynamicBlockGenericConverterRule,
    UserInputBlockGenericConverterRule,
    QuickRepliesBlockGenericConverterRule,
    CardsBlockGenericConverterRule,
    SubscribeRequestBlockGenericConverterRule,
  ],
  FallbackBlockGenericConverterRule,
)
